import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import { EditorState } from "draft-js";
import { Grid, Typography } from "@mui/material";
import ValidatorSelectField from "../../FormFields/ValidatorSelectField";
import { isRequired, maxStringLength, minStringLength } from "../../../services/validationRules";
import MenuItem from "@mui/material/MenuItem";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import MessageFormEditor from "./MessageFormEditor";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

type MessageFormStepInnerProps = {
  product: AbstractCase;
  setEditorState: Function;
  isConversationAnswer: boolean;
  editorState: EditorState;
  currentEditorStatePlainTextLength: number;
  editorStateLengthError: string | null;
};

export default function MessageFormStepInner({
  product,
  editorState,
  setEditorState,
  editorStateLengthError,
  currentEditorStatePlainTextLength,
  isConversationAnswer,
}: MessageFormStepInnerProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            Nachricht verfassen
          </Typography>
        </Grid>
        {!product.isCustomerDataCompleted && (
          <Grid item xs={12}>
            <Typography sx={{ textAlign: "center", color: "error.main" }}>
              Achtung, Ihr Fall ist bislang nicht vollständig. Wir können Ihnen inhaltlich nur weiterhelfen, wenn Sie den Fall zunächst vervollständigen. Bitte
              stellen Sie uns daher hier nur technische Fragen zur Servicewelt.
            </Typography>
          </Grid>
        )}
        {!isConversationAnswer && (
          <Grid item xs={12}>
            <ValidatorSelectField
              name={"type"}
              label={"Nachrichtenkategorie"}
              validators={[
                {
                  validator: isRequired,
                  message: "Bitte wählen Sie aus, welche Art von Nachricht Sie schreiben möchten.",
                },
              ]}
            >
              {product.isCustomerDataCompleted && <MenuItem value={"submitCaseInfo"}>Weitere Infos/ Neuigkeiten zu meinem Fall mitteilen</MenuItem>}
              {product.isCustomerDataCompleted && <MenuItem value={"questionNextSteps"}>Rückfrage zum weiteren Vorgehen</MenuItem>}
              {product.isCustomerDataCompleted && <MenuItem value={"legalQuestion"}>Rechtliche Frage an den Anwalt</MenuItem>}
              <MenuItem value={"technicalQuestion"}>Frage zur Servicewelt</MenuItem>
              {product.isCustomerDataCompleted && <MenuItem value={"other"}>Allgemeine Nachricht</MenuItem>}
            </ValidatorSelectField>
          </Grid>
        )}
        {!isConversationAnswer && (
          <Grid item xs={12}>
            <ValidatorTextField
              name={"subject"}
              label={"Nachrichtenbetreff"}
              validators={[
                {
                  validator: isRequired,
                  message: "Bitte geben Sie Ihrer Nachricht einen sprechenden Betreff, der den Inhalt kurz zusammenfasst.",
                },
                {
                  validator: minStringLength,
                  params: [5],
                  message: "Bitte geben Sie mindestens 5 Zeichen ein",
                },
                {
                  validator: maxStringLength,
                  params: [80],
                  message: "Bitte geben Sie maximal 80 Zeichen ein",
                },
              ]}
            />
          </Grid>
        )}

        <MessageFormEditor
          editorState={editorState}
          setEditorState={setEditorState}
          currentEditorStatePlainTextLength={currentEditorStatePlainTextLength}
          editorStateLengthError={editorStateLengthError}
        />

        <Grid item xs={12} md={6}>
          <Button fullWidth component={Link} to={"/servicewelt/nachrichten"}>
            Zurück
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button fullWidth variant={"contained"} type={"submit"}>
            Weiter
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
